<template>
	<div>
		<div class="center dialog-flex" v-if="isTab === 1">
			<div>
				<!-- <span class="dialog-tag">참여자 정보</span> -->
				<table class="tb-crud-horizon popup-table">
					<colgroup>
						<col width="140px" />
						<col width="30%" />
						<col width="140px" />
						<col width="30%" />
					</colgroup>
					<tbody>
						<tr style="border-top: 1px solid #191C26">
							<th>참여자 번호</th>
							<td>
								<div>{{ item.id }}</div>
							</td>
							<th>생년월일</th>
							<td>
								<div v-if="updateMode == 'N'">{{ item.birth.substring(0,11) }}</div>
								<label 
									v-if="updateMode == 'Y'"
									class="label-date-picker"
									style="width: 100%; height: 32px;"
									:style="utils.isEmpty(item.birth)? 'color: #ccc' : 'color: #090909'"
								>
									{{
										(
											utils.isEmpty(item.birth) ? "YYYY-MM-DD" : item.birth.substring(0, 11)
										) 
									}} 
									<i class="mx-icon">
										<i class="mx-icon-calendar">
												<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="1em" height="1em">
													<path d="M940.218182 107.054545h-209.454546V46.545455h-65.163636v60.50909H363.054545V46.545455H297.890909v60.50909H83.781818c-18.618182 0-32.581818 13.963636-32.581818 32.581819v805.236363c0 18.618182 13.963636 32.581818 32.581818 32.581818h861.090909c18.618182 0 32.581818-13.963636 32.581818-32.581818V139.636364c-4.654545-18.618182-18.618182-32.581818-37.236363-32.581819zM297.890909 172.218182V232.727273h65.163636V172.218182h307.2V232.727273h65.163637V172.218182h176.872727v204.8H116.363636V172.218182h181.527273zM116.363636 912.290909V442.181818h795.927273v470.109091H116.363636z">
													</path>
												</svg>
											</i>
										<i class="mx-icon-clear"
											@click="clearDate()"
										>
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="1em" height="1em">
												<path d="M810.005333 274.005333l-237.994667 237.994667 237.994667 237.994667-60.010667 60.010667-237.994667-237.994667-237.994667 237.994667-60.010667-60.010667 237.994667-237.994667-237.994667-237.994667 60.010667-60.010667 237.994667 237.994667 237.994667-237.994667z">
												</path>
											</svg>
										</i>
									</i>
									<date-picker
										ref="date-picker"
										v-model="item.birth"
										value-type="format"
										format="YYYY-MM-DD"
										style="width: 0px; height: 0px; overflow: hidden;"
										name="informedConsentDt"
										data-vv-as="Consent Date"
										confirm
									/>
								</label>
							</td>
						</tr>
						<tr>
							<th>이름</th>
							<td>
								<div v-if="updateMode == 'N'">{{ item.name }}</div>
								<input
									v-if="updateMode == 'Y'"
									type="text"
									v-model="item.name"
									class="input-crud"
									autocomplete="off"
									data-vv-name="id"
									style="height: 32px;"
								/>
							</td>
							<th>전화번호</th>
							<td>
								<div v-if="updateMode == 'N'">{{ item.phone }}</div>
								<input
									v-if="updateMode == 'Y'"
									type="text"
									v-model="item.phone"
									class="input-crud"
									autocomplete="off"
									data-vv-name="id"
									style="height: 32px;"
								/>
							</td>
						</tr>
						<tr>
							<th>키</th>
							<td>
								<div v-if="updateMode == 'N'">{{ item.tall }}</div>
								<input
									v-if="updateMode == 'Y'"
									type="text"
									v-model="item.tall"
									class="input-crud"
									autocomplete="off"
									data-vv-name="id"
									style="height: 32px;"
								/>
							</td>
							<th>체중 (임신 전)</th>
							<td>
								<div v-if="updateMode == 'N'">{{ item.weight }}</div>
								<input
									v-if="updateMode == 'Y'"
									type="text"
									v-model="item.weight"
									class="input-crud"
									autocomplete="off"
									data-vv-name="id"
									style="height: 32px;"
								/>
							</td>
						</tr>
						<tr>
							<th>임신 주수</th>
							<td>
								<div v-if="updateMode == 'N'">{{ item.weeks }}</div>
								<input
									v-if="updateMode == 'Y'"
									type="number"
									v-model="item.weeks"
									class="input-crud"
									autocomplete="off"
									data-vv-name="id"
									style="height: 32px;"
									min="0"
									max="45"
								/>
							</td>
							<th>분만 예정일</th>
							<td>
								<div v-if="updateMode == 'N'">{{ item.childBirth.substring(0,11) }}</div>
								<label 
									v-if="updateMode == 'Y'"
									class="label-date-picker"
									style="width: 100%; height: 32px;"
									:style="utils.isEmpty(item.childBirth)? 'color: #ccc' : 'color: #090909'"
								>
									{{
										(
											utils.isEmpty(item.childBirth) ? "YYYY-MM-DD" : item.childBirth.substring(0, 11)
										) 
									}} 
									<i class="mx-icon">
										<i class="mx-icon-calendar">
												<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="1em" height="1em">
													<path d="M940.218182 107.054545h-209.454546V46.545455h-65.163636v60.50909H363.054545V46.545455H297.890909v60.50909H83.781818c-18.618182 0-32.581818 13.963636-32.581818 32.581819v805.236363c0 18.618182 13.963636 32.581818 32.581818 32.581818h861.090909c18.618182 0 32.581818-13.963636 32.581818-32.581818V139.636364c-4.654545-18.618182-18.618182-32.581818-37.236363-32.581819zM297.890909 172.218182V232.727273h65.163636V172.218182h307.2V232.727273h65.163637V172.218182h176.872727v204.8H116.363636V172.218182h181.527273zM116.363636 912.290909V442.181818h795.927273v470.109091H116.363636z">
													</path>
												</svg>
											</i>
										<i class="mx-icon-clear"
											@click="clearDate()"
										>
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="1em" height="1em">
												<path d="M810.005333 274.005333l-237.994667 237.994667 237.994667 237.994667-60.010667 60.010667-237.994667-237.994667-237.994667 237.994667-60.010667-60.010667 237.994667-237.994667-237.994667-237.994667 60.010667-60.010667 237.994667 237.994667 237.994667-237.994667z">
												</path>
											</svg>
										</i>
									</i>
									<date-picker
										ref="date-picker"
										v-model="item.childBirth"
										value-type="format"
										format="YYYY-MM-DD"
										style="width: 0px; height: 0px; overflow: hidden;"
										name="informedConsentDt"
										data-vv-as="Consent Date"
										confirm
									/>
								</label>
							</td>
						</tr>
						<tr>
							<th>응급 지원</th>
							<td>
								<div>{{ participantVo.supportCnt }}회</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div class="center dialog-flex" v-if="updateMode == 'N'">
			<div>
				<span class="dialog-tag">데이터 미전송 내역</span>
				<table class="tb-crud-horizon popup-table" style="margin-top: 12.5px;">
					<colgroup>
					</colgroup>
					<tbody>
						<tr style="border-top: 1px solid #191C26">
							<th style="text-align: center; border-right: 1px solid #ddd;">일자</th>
							<th style="text-align: center; border-right: 1px solid #ddd;">분류</th>
							<th style="text-align: center;">담당자 확인</th>
						</tr>
						<template
							v-for="(sent, index) in item.notSentList"
						>
							<tr :key="index+'sent'">
								<td style="border-left: none;">
								</td>
								<td>
								</td>
								<td>
								</td>
							</tr>
						</template>
						<tr v-if="notSentList.length == 0">
							<td colspan="3" style="border: none; text-align: center;" class="no-list">
								데이터 미전송 내역이 없습니다.
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div class="center dialog-flex" v-if="isTab === 1">
			<div>
				<span class="dialog-tag">알림 데이터 범위</span>
				<table class="tb-crud-horizon popup-table" style="margin-top: 12.5px;">
					<colgroup>
						<col width="140px">
						<col width="350px">
					</colgroup>
					<tbody>
						<tr style="border-top: 1px solid #191C26">
							<th style="text-align: center; border-right: 1px solid #ddd;">분류</th>
							<th style="text-align: center; border-right: 1px solid #ddd;" class="font-yellow">주의</th>
							<th style="text-align: center;" class="font-red">경고</th>
						</tr>
						<tr>
							<th style="border-left: none; text-align: center; border-right: 1px solid #ddd;">
								비고
							</th>
							<td colspan="2">
								<div v-if="updateMode == 'N'">
									{{ item.etc != '' ? item.etc : '-' }}
								</div>
								<input
									v-if="updateMode == 'Y'"
									type="text"
									v-model="item.etc"
									class="input-crud"
									autocomplete="off"
									data-vv-name="id"
									style="height: 32px;"
									maxlength="500"
								/>
							</td>
						</tr>
						<tr>
							<th style="border-left: none; text-align: center; border-right: 1px solid #ddd;">
								혈당(공복)
							</th>
							<td>
								<div v-if="updateMode == 'N'">
									{{ item.caution.bloodGlucoseHigh }}
									mg/dL
									<span style="color: #A9A9A9;">이상 고혈당</span>
								</div>
								<div v-if="updateMode == 'N'">
									{{ item.caution.bloodGlucoseLow }}
									mg/dL
									<span style="color: #A9A9A9;">이하 저혈당</span>
								</div>
								<div v-if="updateMode == 'Y'">
									<input
										type="text"
										v-model="item.caution.bloodGlucoseHigh"
										class="input-crud"
										autocomplete="off"
										data-vv-name="id"
										style="width: 60px; height: 32px;"
										maxlength="3"
									/>
									mg/dL
									<span style="color: #A9A9A9;">이상 고혈당</span>
									<br>
									<br>
									<input
										type="text"
										v-model="item.caution.bloodGlucoseLow"
										class="input-crud"
										autocomplete="off"
										data-vv-name="id"
										style="width: 60px; height: 32px;"
										maxlength="3"
									/>
									mg/dL
									<span style="color: #A9A9A9;">이하 저혈당</span>
								</div>
							</td>
							<td>
								<div v-if="updateMode == 'N'">
									{{ item.emergency.bloodGlucoseHigh }}
									mg/dL
									<span style="color: #A9A9A9;">이상 고혈당</span>
								</div>
								<div v-if="updateMode == 'N'">
									{{ item.emergency.bloodGlucoseLow }}
									mg/dL
									<span style="color: #A9A9A9;">이상 저혈당</span>
								</div>
								<div v-if="updateMode == 'Y'">
									<input
										type="text"
										v-model="item.emergency.bloodGlucoseHigh"
										class="input-crud"
										autocomplete="off"
										data-vv-name="id"
										style="width: 60px; height: 32px;"
										maxlength="3"
									/>
									mg/dL
									<span style="color: #A9A9A9;">이상 고혈당</span>
									<br>
									<br>
									<input
										type="text"
										v-model="item.emergency.bloodGlucoseLow"
										class="input-crud"
										autocomplete="off"
										data-vv-name="id"
										style="width: 60px; height: 32px;"
										maxlength="3"
									/>
									mg/dL
									<span style="color: #A9A9A9;">이하 저혈당</span>
								</div>
							</td>
						</tr>
						<tr>
							<th style="border-left: none; text-align: center; border-right: 1px solid #ddd;">
								혈당(식후)
							</th>
							<td>
								<div v-if="updateMode == 'N'">
									{{ item.caution.bloodGlucoseEat }}
									mg/dL
									<span style="color: #A9A9A9;">이상</span>
								</div>
								<div v-if="updateMode == 'Y'">
									<input
										type="text"
										v-model="item.caution.bloodGlucoseEat"
										class="input-crud"
										autocomplete="off"
										data-vv-name="id"
										style="width: 60px; height: 32px;"
										maxlength="3"
									/>
									mg/dL
									<span style="color: #A9A9A9;">이상</span>
								</div>
							</td>
							<td>
								<div v-if="updateMode == 'N'">
									{{ item.emergency.bloodGlucoseEat }}
									mg/dL
									<span style="color: #A9A9A9;">이상</span>
								</div>
								<div v-if="updateMode == 'Y'">
									<input
										type="text"
										v-model="item.emergency.bloodGlucoseEat"
										class="input-crud"
										autocomplete="off"
										data-vv-name="id"
										style="width: 60px; height: 32px;"
										maxlength="3"
									/>
									mg/dL
									<span style="color: #A9A9A9;">이상</span>
								</div>
							</td>
						</tr>
						<tr>
							<th style="border-left: none; text-align: center; border-right: 1px solid #ddd;">
								산소포화도
							</th>
							<td>
								<div v-if="updateMode == 'N'">
									{{ item.caution.oxygenSaturation }}
									%
									<span style="color: #A9A9A9;">이하</span>
								</div>
								<div v-if="updateMode == 'Y'">
									<input
										type="text"
										v-model="item.caution.oxygenSaturation"
										class="input-crud"
										autocomplete="off"
										data-vv-name="id"
										style="width: 60px; height: 32px;"
										maxlength="3"
									/>
									%
									<span style="color: #A9A9A9;">이하</span>
								</div>
							</td>
							<td>
								<div v-if="updateMode == 'N'">
									{{ item.emergency.oxygenSaturation }}
									%
									<span style="color: #A9A9A9;">이하</span>
								</div>
								<div v-if="updateMode == 'Y'">
									<input
										type="text"
										v-model="item.emergency.oxygenSaturation"
										class="input-crud"
										autocomplete="off"
										data-vv-name="id"
										style="width: 60px; height: 32px;"
										maxlength="3"
									/>
									%
									<span style="color: #A9A9A9;">이하</span>
								</div>
							</td>
						</tr>
						<tr>
							<th style="border-left: none; text-align: center; border-right: 1px solid #ddd;">
								혈압(고)
							</th>
							<td>
								<div v-if="updateMode == 'N'">
									수축기 {{ item.caution.bloodPressureSystolicHigh }}
									mg/dL
									<span style="color: #A9A9A9;">이상</span>
								</div>
								<div v-if="updateMode == 'N'">
									이완기 {{ item.caution.bloodPressureDiastolicHigh }}
									mg/dL
									<span style="color: #A9A9A9;">이상</span>
								</div>
								<div v-if="updateMode == 'Y'">
									수축기
									<input
										type="text"
										v-model="item.caution.bloodPressureSystolicHigh"
										class="input-crud"
										autocomplete="off"
										data-vv-name="id"
										style="width: 60px; height: 32px;"
										maxlength="3"
									/>
									mg/dL
									<span style="color: #A9A9A9;">이상</span>
									<br>
									<br>
									이완기
									<input
										type="text"
										v-model="item.caution.bloodPressureDiastolicHigh"
										class="input-crud"
										autocomplete="off"
										data-vv-name="id"
										style="width: 60px; height: 32px;"
										maxlength="3"
									/>
									mg/dL
									<span style="color: #A9A9A9;">이상</span>
								</div>
							</td>
							<td>
								<div v-if="updateMode == 'N'">
									수축기 {{ item.emergency.bloodPressureSystolicHigh }}
									mg/dL
									<span style="color: #A9A9A9;">이상</span>
								</div>
								<div v-if="updateMode == 'N'">
									이완기 {{ item.emergency.bloodPressureDiastolicHigh }}
									mg/dL
									<span style="color: #A9A9A9;">이상</span>
								</div>
								<div v-if="updateMode == 'Y'">
									수축기
									<input
										type="text"
										v-model="item.emergency.bloodPressureSystolicHigh"
										class="input-crud"
										autocomplete="off"
										data-vv-name="id"
										style="width: 60px; height: 32px;"
										maxlength="3"
									/>
									mg/dL
									<span style="color: #A9A9A9;">이상</span>
									<br>
									<br>
									이완기
									<input
										type="text"
										v-model="item.emergency.bloodPressureDiastolicHigh"
										class="input-crud"
										autocomplete="off"
										data-vv-name="id"
										style="width: 60px; height: 32px;"
										maxlength="3"
									/>
									mg/dL
									<span style="color: #A9A9A9;">이상</span>
								</div>
							</td>
						</tr>
						<tr>
							<th style="border-left: none; text-align: center; border-right: 1px solid #ddd;">
								혈압(저)
							</th>
							<td>
								<div v-if="updateMode == 'N'">
									수축기 {{ item.caution.bloodPressureSystolicLow }}
									mg/dL
									<span style="color: #A9A9A9;">이하</span>
								</div>
								<div v-if="updateMode == 'N'">
									이완기 {{ item.caution.bloodPressureDiastolicLow }}
									mg/dL
									<span style="color: #A9A9A9;">이하</span>
								</div>
								<div v-if="updateMode == 'Y'">
									수축기
									<input
										type="text"
										v-model="item.caution.bloodPressureSystolicLow"
										class="input-crud"
										autocomplete="off"
										data-vv-name="id"
										style="width: 60px; height: 32px;"
										maxlength="3"
									/>
									mg/dL
									<span style="color: #A9A9A9;">이하</span>
									<br>
									<br>
									이완기
									<input
										type="text"
										v-model="item.caution.bloodPressureDiastolicLow"
										class="input-crud"
										autocomplete="off"
										data-vv-name="id"
										style="width: 60px; height: 32px;"
										maxlength="3"
									/>
									mg/dL
									<span style="color: #A9A9A9;">이하</span>
								</div>
							</td>
							<td>
								<div v-if="updateMode == 'N'">
									수축기 {{ item.emergency.bloodPressureSystolicLow }}
									mg/dL
									<span style="color: #A9A9A9;">이하</span>
								</div>
								<div v-if="updateMode == 'N'">
									이완기 {{ item.emergency.bloodPressureDiastolicLow }}
									mg/dL
									<span style="color: #A9A9A9;">이하</span>
								</div>
								<div v-if="updateMode == 'Y'">
									수축기
									<input
										type="text"
										v-model="item.emergency.bloodPressureSystolicLow"
										class="input-crud"
										autocomplete="off"
										data-vv-name="id"
										style="width: 60px; height: 32px;"
										maxlength="3"
									/>
									mg/dL
									<span style="color: #A9A9A9;">이하</span>
									<br>
									<br>
									이완기
									<input
										type="text"
										v-model="item.emergency.bloodPressureDiastolicLow"
										class="input-crud"
										autocomplete="off"
										data-vv-name="id"
										style="width: 60px; height: 32px;"
										maxlength="3"
									/>
									mg/dL
									<span style="color: #A9A9A9;">이하</span>
								</div>
							</td>
						</tr>
						<tr>
							<th style="border-left: none; text-align: center; border-right: 1px solid #ddd;">
								심박수
							</th>
							<td>
								<div v-if="updateMode == 'N'">
									{{ item.caution.heartRate }}
									bpm
									<span style="color: #A9A9A9;">이상</span>
								</div>
								<div v-if="updateMode == 'Y'">
									<input
										type="text"
										v-model="item.caution.heartRate"
										class="input-crud"
										autocomplete="off"
										data-vv-name="id"
										style="width: 60px; height: 32px;"
										maxlength="3"
									/>
									bpm
									<span style="color: #A9A9A9;">이상</span>
								</div>
							</td>
							<td>
								<div v-if="updateMode == 'N'">
									{{ item.emergency.heartRate }}
									bpm
									<span style="color: #A9A9A9;">이상</span>
								</div>
								<div v-if="updateMode == 'Y'">
									<input
										type="text"
										v-model="item.emergency.heartRate"
										class="input-crud"
										autocomplete="off"
										data-vv-name="id"
										style="width: 60px; height: 32px;"
										maxlength="3"
									/>
									bpm
									<span style="color: #A9A9A9;">이상</span>
								</div>
							</td>
						</tr>
						<tr>
							<th style="border-left: none; text-align: center; border-right: 1px solid #ddd;">
								체중
							</th>
							<td>
								<div v-if="updateMode == 'N'">
									이전 수치 기준 + {{ item.caution.weight }} kg 초과 {{ item.emergency.weight }} kg 이하
								</div>
								<div v-if="updateMode == 'Y'">
									이전 수치 기준 +
									<input
										type="text"
										v-model="item.caution.weight"
										class="input-crud"
										autocomplete="off"
										style="width: 60px; height: 32px;"
										maxlength="5"
									/>
									kg 초과
									<input
										type="text"
										v-model="item.emergency.weight"
										class="input-crud"
										autocomplete="off"
										style="width: 60px; height: 32px;"
										maxlength="5"
									/>
									kg 이하
								</div>
							</td>
							<td>
								<div v-if="updateMode == 'N'">
									이전 수치 기준 + {{ item.emergency.weight }} kg 초과
								</div>
								<div v-if="updateMode == 'Y'">
									이전 수치 기준 +
									<input
										type="text"
										v-model="item.emergency.weight"
										class="input-crud"
										autocomplete="off"
										style="width: 60px; height: 32px;"
										maxlength="5"
									/>
									kg 초과
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div class="center dialog-flex">
			<div>
				<div style="display: flex; justify-content: space-between; align-items: center;">
					<span class="dialog-tag">고위험 임신 요인(중증)</span>
				</div>
				<div style="margin-top: 12.5px; border-top: 1px solid #191C26; border-bottom: 1px solid #ddd; padding: 10px 5px;">
					<label
						v-for="(option, checkboxIndex) in dangerSevere"
						:key="checkboxIndex+'severe'"
						class="checkbox-dic"
					>
						<input
							type="checkbox"
							:value="checkboxIndex"
							v-model="item.dangerSevereList"
							:disabled="updateMode == 'N'"
						/><span class="checkbox"></span>
						<p><b style="color:#666;">{{option}}</b></p>
					</label>
					<p style="color: #aaa; font-size: 14px;">
						※기타 중증 내과적·외과적 질환 : 악성종양, 뇌혈관질환, 뇌성마비, 척수손상, 백혈병, 재생불량성빈혈, 혈소판 감소증, 혈액응고질환, 심부정맥혈전증, 폐색전증, 근무력증, 장기이식, 간경화, 활동성B형간염보균, 사람면역결핍바이러스 감염, 정신과적 질환, 약물로 조절되지 않는 간질, 활동성 자가면역질환, 임신 중 수술
					</p>
				</div>
			</div>
		</div>
		<div class="center dialog-flex">
			<div>
				<div style="display: flex; justify-content: space-between; align-items: center;">
					<span class="dialog-tag">고위험 임신 요인(경증)</span>
				</div>
				<div style="margin-top: 12.5px; border-top: 1px solid #191C26; border-bottom: 1px solid #ddd; padding: 10px 5px;">
					<label
						v-for="(option, checkboxIndex) in dangerMild"
						:key="checkboxIndex+'mild'"
						class="checkbox-dic"
					>
						<input
							type="checkbox"
							:value="checkboxIndex"
							v-model="item.dangerMildList"
							:disabled="updateMode == 'N'"
						/><span class="checkbox"></span>
						<p><b style="color:#666;">{{option}}</b></p>
					</label>
				</div>
			</div>
		</div>
		<div class="center dialog-flex">
			<div>
				<div style="display: flex; justify-content: space-between; align-items: center;">
					<span class="dialog-tag">고위험 임신 요인(기타)</span>
					<button v-if="updateMode == 'Y'" class="add-btn" type="button" style="min-width: 80px; width: 80px; height: 32px;" @click.stop="addAction()">추가</button>
				</div>
				<table class="tb-crud-horizon popup-table" style="margin-top: 12.5px;">
					<colgroup>
						<col width="140px">
					</colgroup>
					<tbody>
						<tr style="border-top: 1px solid #191C26">
							<th style="text-align: center; border-right: 1px solid #ddd;">번호</th>
							<th style="text-align: center;">내용</th>
						</tr>
						<template
							v-for="(danger, index) in item.dangerEtcList"
						>
							<tr
								:key="index"
							>
								<th style="border-left: none; text-align: center;">
									{{ index + 1 }}
								</th>
								<td
									v-if="updateMode == 'Y'"	
								>
									<input
										type="text"
										v-model="danger.value"
										class="input-crud"
										autocomplete="off"
										data-vv-name="id"
										style="width: 90%; height: 32px;"
									/>
									<button type="button" class="fright minus-btn" @click.stop="delList(index)">-</button>
								</td>
								<td
									v-if="updateMode == 'N'"
								>
								{{ danger.value }}
								</td>
							</tr>
						</template>
						<tr v-if="item.dangerEtcList.length == 0">
							<td colspan="2" style="border: none; text-align: center;" class="no-list">
								고위험 임신 요인이 없습니다.
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div class="bottom" style="display: flex; justify-content: center; column-gap: 10px;">
			<button v-if="updateMode == 'Y'" type="button" class="btn-save" title="Save" @click.stop="doValidation()">
				저장
			</button>
			<button v-if="updateMode == 'Y'" type="button" class="btn-save" style="background-color: #F94848;" title="Reset" @click.stop="resetPassword()">
				비밀번호 초기화
			</button>
			<button v-if="updateMode == 'N'" type="button" class="btn-cancel" style="margin: 0;" title="Update" @click.stop="changeUpdateMode('Y')">
				수정
			</button>
			<button v-if="updateMode == 'Y'" type="button" class="btn-cancel" style="margin: 0;" title="Update" @click.stop="changeUpdateMode('N')">
				취소
			</button>
			<button type="button" class="btn-cancel" style="margin: 0;" title="Cancel" @click.stop="doCancel()">
				닫기
			</button>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import EventBus from "@/script/EventBus.js";
import moment from "moment";
import DatePicker from 'vue2-datepicker';

export default {
	name: "ParticipantInfo",
	created() {
		this.logger.debug(this, "created()");
		this.firstRegistDate = moment().format("YYYY-MM-DD");
		this.firstRegistUserId = this.userInfo.userId;
		this.firstRegistUserName = this.userInfo.userName;
		this.selectParticipantInfo();
	},
	props: {
		collectData: {
			type: Object,
			required: true
		}
	},
	components:{
		DatePicker,
	},
	data() {
		return {
			item: {
				userId: sessionStorage.getItem('userId'),
				etc:"",
				id:"",
				name:"",
				phone:"",
				tall:"",
				weeks:"",
				weight:"",
				birth: "",
				childBirth: "",
				caution: {
					bloodGlucoseHigh:"",
					bloodGlucoseLow:"",
					bloodGlucoseEat:"",
					oxygenSaturation:"",
					bloodPressureSystolicHigh:"",
					bloodPressureSystolicLow:"",
					bloodPressureDiastolicHigh:"",
					bloodPressureDiastolicLow:"",
					heartRate:"",
					weight:""
				},
				emergency: {
					bloodGlucoseHigh:"",
					bloodGlucoseLow:"",
					bloodGlucoseEat:"",
					oxygenSaturation:"",
					bloodPressureSystolicHigh:"",
					bloodPressureSystolicLow:"",
					bloodPressureDiastolicHigh:"",
					bloodPressureDiastolicLow:"",
					heartRate:"",
					weight:""
				},
				dangerSevereList: [],
				dangerMildList: [],
				dangerEtcList: [],
			},
			items: {},
			isTab: 1,
			updateMode: 'N',
			participantVo: {},
			notSentList: [],
			dangerList: [],
			dangerSevere: [
				"직전 임신 시 전자간증(임신중독)의 병력",
				"신장질환 보유",
				"심장질환 보유",
				"자가면역질환 (전신홍반루프스, 항인지질항체증후군) 보유",
				"제1,2형 당뇨병 보유",
				"다태임신",
				"만성고혈압",
				"이전의 신생아(생후 1개월) 사망 과거력",
				"용혈성 질환으로 인한 태아 수혈의 과거력",
				"산후출혈(자궁파열 포함)의 과거력",
				"근치적자궁경부 절제술(trachelectomy)의 과거력",
				"40세 이상",
				"BMI ≥ 30kg/㎡",
				"자궁경관무력증",
				"자궁기형",
				"기타 중증 내과적·외과적 질환",
			],
			dangerMild: [
				"초산모",
				"35세 이상 39세 이하",
				"이전 임신 후 현재 임신 사이 기간이 10년 이상인 경우",
				"전자간증의 가족력(엄마, 언니, 동생)",
				"키 152cm미만",
				"조산아 출산 경험",
				"저체중아(2.5kg미만) 출산 경험",
				"과체중아(4.5kg이상) 출산 경험",
				"자연유산 경험",
				"여러 번의 유산 병력",
				"42주 이후 자연 출산 경험",
				"RH 음성",
				"양수과다 또는 양수과소 경험",
				"자궁외임신 경험",
				"난산 경험(둔위, 견갑 만출장애 등)",
				"선천성 결함, 뇌성마비 아기 출산 경험",
				"성매개 감염병(HIV, 매독, 임질 등) 경험",
				"간질",
				"폐질환",
				"갑상선질환",
				"빈혈",
				"흡연 ≥ 1pack/일",
				"약물/알코올 남용",
				"전자간증(임신중독) 병력(직전 임신 제외)",
			],
		};
	},
	methods: {
		doValidation() {
			this.logger.debug(this, "doValidation()");
			this.$validator
				.validateAll()
				.then((result) => {
					this.logger.debug(this, "doValidationResult:" + result);
					if (result)
					{
						this.$confirm("참여자 정보를 수정 하시겠습니까?", "Question", "question").then(() => {
							EventBus.$emit("field-loading", true);
							this.doInsert();
						});
					}
				})
				.catch(() => {
					this.logger.debug(this, "-->" + this.errors.all());
					alert(this.errors.all());
					return false;
				});
		},
		resetPassword() {
			this.logger.debug(this, "resetPassword()");
			this.$confirm("참여자 비밀번호를 초기화 하시겠습니까?", "Question", "question").then(() => {
				EventBus.$emit("field-loading", true);
				this.doReset();
			});
		},
		selectParticipantInfo(){
			this.logger.debug(this, "selectParticipantInfo()");
			this.openProjectIndex = -1;
			axios
				.post(this.config.contextRoot + "/participant/selectParticipantInfo.do", this.collectData)
				.then((response) => {
					console.log(response);
					
					this.participantVo = response.data.participantVo;
					this.item.etc = this.participantVo.etc;
					this.item.id = this.participantVo.id;
					this.item.name = this.participantVo.name;
					this.item.phone = this.participantVo.phone;
					this.item.tall = this.participantVo.tall;
					this.item.weeks = this.participantVo.weeks;
					this.item.weight = this.participantVo.weight;
					this.item.birth = this.participantVo.birth;
					this.item.childBirth = this.participantVo.childBirth;
					this.dangerList = JSON.parse(JSON.stringify(this.participantVo.dangerList));
					if(this.dangerList.length > 0){
						for(var d = 0; d < this.dangerList.length; d++){
							if(this.dangerList[d].dangerType == "SEVERE"){
								this.item.dangerSevereList = this.dangerList[d].value.split(",");
							}
							if(this.dangerList[d].dangerType == "MILD"){
								this.item.dangerMildList = this.dangerList[d].value.split(",");
							}
							if(this.dangerList[d].dangerType == "ETC"){
								this.item.dangerEtcList.push(this.dangerList[d]);
							}
						}
					}

					for(var i = 0; i < this.participantVo.statusList.length; i++){
						if(this.participantVo.statusList[i].status == 'CAUTION'){
							if(this.participantVo.statusList[i].recordType == 'BLOOD_GLUCOSE'){
								if(this.participantVo.statusList[i].glucoseType == 'HIGH'){
									this.item.caution.bloodGlucoseHigh = this.participantVo.statusList[i].value;
								}
								else if(this.participantVo.statusList[i].glucoseType == 'LOW'){
									this.item.caution.bloodGlucoseLow = this.participantVo.statusList[i].value;
								}
								else if(this.participantVo.statusList[i].glucoseType == 'EAT'){
									this.item.caution.bloodGlucoseEat = this.participantVo.statusList[i].value;
								}
							}
							if(this.participantVo.statusList[i].recordType == 'OXYGEN_SATURATION'){
								this.item.caution.oxygenSaturation = this.participantVo.statusList[i].value;
							}
							if(this.participantVo.statusList[i].recordType == 'BLOOD_PRESSURE'){
								if(this.participantVo.statusList[i].highPressYn == 'Y'){
									this.item.caution.bloodPressureSystolicHigh = this.participantVo.statusList[i].value;
									this.item.caution.bloodPressureDiastolicHigh = this.participantVo.statusList[i].subValue;
								}
								else if(this.participantVo.statusList[i].highPressYn == 'N'){
									this.item.caution.bloodPressureSystolicLow = this.participantVo.statusList[i].value;
									this.item.caution.bloodPressureDiastolicLow = this.participantVo.statusList[i].subValue;
								}
							}
							if(this.participantVo.statusList[i].recordType == 'HEART_RATE'){
								this.item.caution.heartRate = this.participantVo.statusList[i].value;
							}
							if(this.participantVo.statusList[i].recordType == 'WEIGHT'){
								this.item.caution.weight = this.participantVo.statusList[i].value;
							}
						}
						if(this.participantVo.statusList[i].status == 'EMERGENCY'){
							if(this.participantVo.statusList[i].recordType == 'BLOOD_GLUCOSE'){
								if(this.participantVo.statusList[i].glucoseType == 'HIGH'){
									this.item.emergency.bloodGlucoseHigh = this.participantVo.statusList[i].value;
								}
								else if(this.participantVo.statusList[i].glucoseType == 'LOW'){
									this.item.emergency.bloodGlucoseLow = this.participantVo.statusList[i].value;
								}
								else if(this.participantVo.statusList[i].glucoseType == 'EAT'){
									this.item.emergency.bloodGlucoseEat = this.participantVo.statusList[i].value;
								}
							}
							if(this.participantVo.statusList[i].recordType == 'OXYGEN_SATURATION'){
								this.item.emergency.oxygenSaturation = this.participantVo.statusList[i].value;
							}
							if(this.participantVo.statusList[i].recordType == 'BLOOD_PRESSURE'){
								if(this.participantVo.statusList[i].highPressYn == 'Y'){
									this.item.emergency.bloodPressureSystolicHigh = this.participantVo.statusList[i].value;
									this.item.emergency.bloodPressureDiastolicHigh = this.participantVo.statusList[i].subValue;
								}
								else if(this.participantVo.statusList[i].highPressYn == 'N'){
									this.item.emergency.bloodPressureSystolicLow = this.participantVo.statusList[i].value;
									this.item.emergency.bloodPressureDiastolicLow = this.participantVo.statusList[i].subValue;
								}
							}
							if(this.participantVo.statusList[i].recordType == 'HEART_RATE'){
								this.item.emergency.heartRate = this.participantVo.statusList[i].value;
							}
							if(this.participantVo.statusList[i].recordType == 'WEIGHT'){
								this.item.emergency.weight = this.participantVo.statusList[i].value;
							}
						}
					}

					EventBus.$emit("project-loading", false);
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doInsert() {
			this.logger.debug(this, "doInsert()");
			if(this.item.id == ''){
				this.$alert("참여자 번호를 입력해주세요.", "Warning", "warning");
				return false;
			}

			axios
				.post(this.config.contextRoot + "/participant/updateParticipant.do", this.item)
				.then((response) => {
					if (response.status == 200)
					{
						console.log(response);
						// location.reload();
						this.$alert("Complete", "Success", "success").then(() => {
							// location.reload();
							this.$parent.$parent.selectParticipantList();
							this.doClose();
						});
					}
					else
					{
						alert(response);
						console.log(response);
					}
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doReset() {
			this.logger.debug(this, "doReset()");
			axios
				.post(this.config.contextRoot + "/participant/resetPassword.do", this.item)
				.then((response) => {
					if (response.status == 200)
					{
						console.log(response);
						// location.reload();
						this.$alert("Complete", "Success", "success").then(() => {
							// location.reload();
							this.$parent.$parent.selectParticipantList();
							this.doClose();
						});
					}
					else
					{
						alert(response);
						console.log(response);
					}
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doCancel() {
			this.logger.debug(this, "doCancel()");
			this.$confirm("취소하시겠습니까?", "Question", "question").then(() => {
				this.doClose();
			});
		},
		doClose() {
			this.logger.debug(this, "doClose()");
			this.$parent.$refs.ParticipantDetail.style.animation = "fadeOut 0.4s ease-in-out both";
			this.$parent.$refs.ParticipantDetail.children[0].style.animation = "fadeOutDrop 0.4s ease-in-out both";
			setTimeout(function() {
				EventBus.$emit("project-cancel", "isDataPopup");
			}.bind(this), 410);
		},
		changeTap(type){
			this.isTab = type;
		},
		changeUpdateMode(mode){
			if(mode == 'Y'){
				this.updateMode = 'Y';
			}
			else{
				this.updateMode = 'N';
				this.item.etc = this.participantVo.etc;
				this.item.id = this.participantVo.id;
				this.item.name = this.participantVo.name;
				this.item.phone = this.participantVo.phone;
				this.item.tall = this.participantVo.tall;
				this.item.weeks = this.participantVo.weeks;
				this.item.weight = this.participantVo.weight;
				this.item.birth = this.participantVo.birth;
				this.item.childBirth = this.participantVo.childBirth;
				this.dangerList = JSON.parse(JSON.stringify(this.participantVo.dangerList));
				this.item.dangerEtcList = [];
				if(this.dangerList.length > 0){
					for(var d = 0; d < this.dangerList.length; d++){
						if(this.dangerList[d].dangerType == "SEVERE"){
							this.item.dangerSevereList = this.dangerList[d].value.split(",");
						}
						if(this.dangerList[d].dangerType == "MILD"){
							this.item.dangerMildList = this.dangerList[d].value.split(",");
						}
						if(this.dangerList[d].dangerType == "ETC"){
							this.item.dangerEtcList.push(this.dangerList[d]);
						}
					}
				}

				for(var i = 0; i < this.participantVo.statusList.length; i++){
					if(this.participantVo.statusList[i].status == 'CAUTION'){
						if(this.participantVo.statusList[i].recordType == 'BLOOD_GLUCOSE'){
							if(this.participantVo.statusList[i].glucoseType == 'HIGH'){
								this.item.caution.bloodGlucoseHigh = this.participantVo.statusList[i].value;
							}
							else if(this.participantVo.statusList[i].glucoseType == 'LOW'){
								this.item.caution.bloodGlucoseLow = this.participantVo.statusList[i].value;
							}
							else if(this.participantVo.statusList[i].glucoseType == 'EAT'){
								this.item.caution.bloodGlucoseEat = this.participantVo.statusList[i].value;
							}
						}
						if(this.participantVo.statusList[i].recordType == 'OXYGEN_SATURATION'){
							this.item.caution.oxygenSaturation = this.participantVo.statusList[i].value;
						}
						if(this.participantVo.statusList[i].recordType == 'BLOOD_PRESSURE'){
							if(this.participantVo.statusList[i].highPressYn == 'Y'){
								this.item.caution.bloodPressureSystolicHigh = this.participantVo.statusList[i].value;
								this.item.caution.bloodPressureDiastolicHigh = this.participantVo.statusList[i].subValue;
							}
							else if(this.participantVo.statusList[i].highPressYn == 'N'){
								this.item.caution.bloodPressureSystolicLow = this.participantVo.statusList[i].value;
								this.item.caution.bloodPressureDiastolicLow = this.participantVo.statusList[i].subValue;
							}
						}
						if(this.participantVo.statusList[i].recordType == 'HEART_RATE'){
							this.item.caution.heartRate = this.participantVo.statusList[i].value;
						}
						if(this.participantVo.statusList[i].recordType == 'WEIGHT'){
							if(this.participantVo.statusList[i].weightDate == 'EARLY'){
								this.item.caution.weightEarly = this.participantVo.statusList[i].value;
							}
							else if(this.participantVo.statusList[i].weightDate == 'MIDDLE'){
								this.item.caution.weightMiddle = this.participantVo.statusList[i].value;
							}
							else if(this.participantVo.statusList[i].weightDate == 'LATE'){
								this.item.caution.weightLate = this.participantVo.statusList[i].value;
							}
						}
					}
					if(this.participantVo.statusList[i].status == 'EMERGENCY'){
						if(this.participantVo.statusList[i].recordType == 'BLOOD_GLUCOSE'){
							if(this.participantVo.statusList[i].glucoseType == 'HIGH'){
								this.item.emergency.bloodGlucoseHigh = this.participantVo.statusList[i].value;
							}
							else if(this.participantVo.statusList[i].glucoseType == 'LOW'){
								this.item.emergency.bloodGlucoseLow = this.participantVo.statusList[i].value;
							}
							else if(this.participantVo.statusList[i].glucoseType == 'EAT'){
								this.item.emergency.bloodGlucoseEat = this.participantVo.statusList[i].value;
							}
						}
						if(this.participantVo.statusList[i].recordType == 'OXYGEN_SATURATION'){
							this.item.emergency.oxygenSaturation = this.participantVo.statusList[i].value;
						}
						if(this.participantVo.statusList[i].recordType == 'BLOOD_PRESSURE'){
							if(this.participantVo.statusList[i].highPressYn == 'Y'){
								this.item.emergency.bloodPressureSystolicHigh = this.participantVo.statusList[i].value;
								this.item.emergency.bloodPressureDiastolicHigh = this.participantVo.statusList[i].subValue;
							}
							else if(this.participantVo.statusList[i].highPressYn == 'N'){
								this.item.emergency.bloodPressureSystolicLow = this.participantVo.statusList[i].value;
								this.item.emergency.bloodPressureDiastolicLow = this.participantVo.statusList[i].subValue;
							}
						}
						if(this.participantVo.statusList[i].recordType == 'HEART_RATE'){
							this.item.emergency.heartRate = this.participantVo.statusList[i].value;
						}
						if(this.participantVo.statusList[i].recordType == 'WEIGHT'){
							if(this.participantVo.statusList[i].weightDate == 'EARLY'){
								this.item.emergency.weightEarly = this.participantVo.statusList[i].value;
							}
							else if(this.participantVo.statusList[i].weightDate == 'MIDDLE'){
								this.item.emergency.weightMiddle = this.participantVo.statusList[i].value;
							}
							else if(this.participantVo.statusList[i].weightDate == 'LATE'){
								this.item.emergency.weightLate = this.participantVo.statusList[i].value;
							}
						}
					}
				}
			}
		},
		clearDate() {
			this.$set(this.items, "informedConsentDt", "");
			this.$set(this.items, "informedConsentDtTemp", "");
			this.$set(this.item, "childBirth", "");
			setTimeout(function() {
				let popup = document.getElementsByClassName("mx-datepicker-popup")[0];
				popup.style.display = "none";
			}.bind(this), 0);
		},
		clearDate2(index) {
			this.$set(this.item.dangerList[index], "dangerDate", "");
			setTimeout(function() {
				let popup = document.getElementsByClassName("mx-datepicker-popup")[0];
				popup.style.display = "none";
			}.bind(this), 0);
		},
		addAction(){
			const item = {
				value: "",
			}
			this.item.dangerEtcList.push(item);
		},
		delList(index){
			if(this.item.dangerEtcList.length > 0){
				this.item.dangerEtcList.splice(index, 1);
			}
		}
	}
};
</script>

<style scoped>
.btn-cancel {
	margin-right: 10px;
}
.popup-table th{
	background-color: #F8F9FB;
}
.popup-table tr:first-child > th{
	border-top: 1px solid #191C26
}
.popup-table tr:first-child > td{
	border-top: 1px solid #191C26
}
.dialog-tag{
	font-size: 18px;
	font-weight: bold;
}
.dialog-flex{
	display: flex;
    column-gap: 40px;
    justify-content: space-between;
	margin: 
}
.dialog-flex > div{
	width: 100%;
}
.popup-table td{
	border-left: 1px solid #ddd;
	border-right: 1px solid #ddd;
}
.popup-table td:last-child{
	border-right: none;
}
.participant-tab-zone{
	width: 100%;
	height: 48px;
	margin-top: 20px;
	background-color: #EBF4FF;
	border-radius: 5px;
	display: flex;
	align-items: center;
	padding: 0 5px;
	column-gap: 5px;
}
.participant-btn{
	height: 40px;
	border-radius: 6px;
	display: flex;
    justify-content: center;
    align-items: center;
	flex: 1;
	color: #090909;
	font-size: 18px;
	cursor: pointer;
}
.participant-btn:hover{
	background-color: #1A7AFF;
	color: #fff;
	box-shadow: 1px 1px 8px 0px rgb(0, 23, 85, 0.2);
}
.participant-on{
	background-color: #1A7AFF;
	color: #fff;
	box-shadow: 1px 1px 8px 0px rgb(0, 23, 85, 0.2);
}
.font-red{
	color: #F94848;
}
.font-yellow{
	color: #FFAD09;
}
.minus-btn{
	width: 32px;
    height: 32px;
    background-color: #555555;
    border-radius: 5px;
    color: #fff;
    font-size: 33px;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>import { split } from "core-js/fn/symbol";
